"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
var utils_1 = require("./utils");
exports.rupees = utils_1.rupees;
var Rupee = function (_a) {
    var value = _a.value, className = _a.className, insertSpaceAfterMinus = _a.insertSpaceAfterMinus, retainDecimalPlaces = _a.retainDecimalPlaces, removeSpaceAfterRupee = _a.removeSpaceAfterRupee;
    return (react_1.default.createElement("span", { className: "rupee-container " + (className ? className : ''), "data-testid": "rupee-value-container" }, typeof (value) !== 'undefined' ?
        utils_1.rupees(value, true, insertSpaceAfterMinus, retainDecimalPlaces, removeSpaceAfterRupee) :
        '₹'));
};
Rupee.propTypes = {
    value: prop_types_1.default.oneOfType([
        prop_types_1.default.string,
        prop_types_1.default.number,
    ]),
    className: prop_types_1.default.string,
    insertSpaceAfterMinus: prop_types_1.default.bool,
    retainDecimalPlaces: prop_types_1.default.bool,
    removeSpaceAfterRupee: prop_types_1.default.bool,
};
exports.default = Rupee;
